import { renderSecondaryNavAppsSection } from './renderSecondaryNavAppsSection'
import { renderSecondaryNavBoardSection } from './renderSecondaryNavBoardSection'
import { renderSecondaryNavChamberAgentSection } from './renderSecondaryNavChamberAgentSection'
import { renderSecondaryNavThreadSection } from './renderSecondaryNavThreadSection'

export function renderSecondaryNavSection(section, ctx) {
  return (
    renderSecondaryNavBoardSection(section, ctx) ??
    renderSecondaryNavAppsSection(section, ctx) ??
    renderSecondaryNavThreadSection(section, ctx) ??
    renderSecondaryNavChamberAgentSection(section, ctx)
  )
}
